module.exports = __webpack_public_path__ + "static/img/UOOYAA_07_51.2bf784d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue11/04/UOOYAA_07_51.jpg
// module id = e/+j
// module chunks = 7